/* tslint:disable */
/* eslint-disable */
/**
 * Neptune Leaderboard REST API
 * Public REST API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: contact@neptune.ml
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { EvaluationChartPoint } from './EvaluationChartPoint';
import {
    EvaluationChartPointFromJSON,
    EvaluationChartPointFromJSONTyped,
    EvaluationChartPointToJSON,
} from './EvaluationChartPoint';
import type { EvaluationChartLabel } from './EvaluationChartLabel';
import {
    EvaluationChartLabelFromJSON,
    EvaluationChartLabelFromJSONTyped,
    EvaluationChartLabelToJSON,
} from './EvaluationChartLabel';

/**
 * 
 * @export
 * @interface EvaluationChartLine
 */
export interface EvaluationChartLine {
    /**
     * Canonical evaluation series UUID of the line's source
     * @type {string}
     * @memberof EvaluationChartLine
     */
    evaluationSeriesId: string;
    /**
     * 
     * @type {Array<EvaluationChartLabel>}
     * @memberof EvaluationChartLine
     */
    labels: Array<EvaluationChartLabel>;
    /**
     * 
     * @type {Array<EvaluationChartPoint>}
     * @memberof EvaluationChartLine
     */
    points: Array<EvaluationChartPoint>;
    /**
     * Zero-based index of the line's source in the request
     * @type {number}
     * @memberof EvaluationChartLine
     */
    sourceIndex: number;
}

/**
 * Check if a given object implements the EvaluationChartLine interface.
 */
export function instanceOfEvaluationChartLine(value: object): value is EvaluationChartLine {
    if (!('evaluationSeriesId' in value) || value['evaluationSeriesId'] === undefined) return false;
    if (!('labels' in value) || value['labels'] === undefined) return false;
    if (!('points' in value) || value['points'] === undefined) return false;
    if (!('sourceIndex' in value) || value['sourceIndex'] === undefined) return false;
    return true;
}

export function EvaluationChartLineFromJSON(json: any): EvaluationChartLine {
    return EvaluationChartLineFromJSONTyped(json, false);
}

export function EvaluationChartLineFromJSONTyped(json: any, ignoreDiscriminator: boolean): EvaluationChartLine {
    if (json == null) {
        return json;
    }
    return {
        
        'evaluationSeriesId': json['evaluationSeriesId'],
        'labels': ((json['labels'] as Array<any>).map(EvaluationChartLabelFromJSON)),
        'points': ((json['points'] as Array<any>).map(EvaluationChartPointFromJSON)),
        'sourceIndex': json['sourceIndex'],
    };
}

export function EvaluationChartLineToJSON(value?: EvaluationChartLine | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'evaluationSeriesId': value['evaluationSeriesId'],
        'labels': ((value['labels'] as Array<any>).map(EvaluationChartLabelToJSON)),
        'points': ((value['points'] as Array<any>).map(EvaluationChartPointToJSON)),
        'sourceIndex': value['sourceIndex'],
    };
}

